import React from 'react'

import { Interviews } from './tabs/Interviews/Interviews'

const INTERVIEWS = 'interviews'

export const TAB_NAMES = {
  INTERVIEWS,
}

export const getTab = (state, dispatch) => {
  const { tab, userName, uuid } = state

  const tabs = {
    [TAB_NAMES.INTERVIEWS]: <Interviews {...{ userName, uuid, dispatch }} />,
  }

  return tabs[tab]
}
